import type { AxiosInstance } from 'axios';
import type { Resource } from './types';

export const getResource = <
  Path extends readonly string[] = readonly string[],
  Params extends Record<string, any> | undefined = undefined,
  Body extends Record<string, any> | undefined = undefined,
>(
  path: Path,
  opts: Partial<Omit<Resource<Path, Params, Body>, 'path'>> = {}
): Resource<Path, Params, Body> => {
  const { method = 'GET', infinite = false, body, params, scope } = opts;

  const resource: Resource<Path, Params, Body> = { path, method, infinite };

  if (body) {
    resource.body = body;
  }

  if (params) {
    resource.params = params;
  }

  if (scope) {
    resource.scope = scope;
  }

  return resource;
};

export const curry1 = <T extends any[] = any[], R = any>(
  fn: (instance: AxiosInstance, ...rest: T) => R
) => {
  return (instance: AxiosInstance) => {
    return (...rest: T) => {
      return fn(instance, ...rest);
    };
  };
};

export const parsePageParam = (value: string | number): number | undefined => {
  if (typeof value === 'number') {
    return value;
  }

  const page = parseInt(value);

  if (!isNaN(page)) {
    return page;
  }
};
